<template>
  <div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <app-cells><h1 class="title">Legal entities</h1></app-cells>
      <table-legal-entities
        :table-items="table_items"
      />
    </template>
  </div>
</template>

<script>
import { getAdministrativeLegalEntities } from '@/http'
import TableLegalEntities from '@/views/administrative/legal-entities/tables/TableLegalEntities'

export default {
  name: 'AdministrativeLegalEntitiesList',
  components: {TableLegalEntities},
  data() {
    return {
      page_loaded: false,
      table_items: [],

    }
  },
  created() {
    getAdministrativeLegalEntities()
      .then(response => {
        this.table_items = response.data
        this.page_loaded = true
      })
  }
}
</script>
